import script from "./MultiSelectComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelectComponent.vue?vue&type=script&setup=true&lang=js"

import "./MultiSelectComponent.vue?vue&type=style&index=0&id=1eb09d2c&lang=css"

const __exports__ = script;

export default __exports__